import { createApp, type Directive } from 'vue';

import { createGtm } from 'vue-gtm';

import App from '@/layout/App/App.vue';
import '@/css/app.css';

import InfoTooltip from '@/components/Tooltip/InfoTooltip.vue';
import DescTooltip from '@/components/Tooltip/DescTooltip.vue';

import { tooltip } from '@/directives/tooltip';
import router from '@/router';
import { featureFlags } from '@/modules/featureFlags';
import { productTour } from '@/modules/productTour';

import i18n from '@/config/i18n';

const gtm = createGtm({
  id: 'GTM-PR875NV',
  loadScript: true,
  vueRouter: router,
});

export const app = createApp(App)
  .use(router)
  .use(i18n)
  .use(featureFlags)
  .use(productTour)
  .use(gtm);

app.component('BmInfoTooltip', InfoTooltip);
app.component('BmDescTooltip', DescTooltip);

app.directive('tooltip', tooltip as Directive);

// This is to avoid first load with all routes pointing to "/" instead of defined path
router.isReady().then(() => app.mount('#app'));
